import utils from '@/utils'
const { hostBusiness } = utils.envVariables

export function placeAnOrder (pid, type) {
  const loginType = localStorage.getItem('loginType')
  const userinfo = JSON.parse(localStorage.getItem('userinfo'))
  const accessTokenInfo = JSON.parse(localStorage.getItem('accessTokenInfo'))
  return this.fetch({
    method: 'GET',
    url: `${hostBusiness}/v3/extend/1/product/getProductDetail.html`,
    params: {
      data: {
        pid
      }
    }
  }).then(pres => {
    const txSource = ['5', '6', '36', '3003']
    const isTxSource = txSource.includes(pres.sourceSign)
    const isTxLoginType = ['weixin', 'qq'].includes(loginType)
    if (userinfo && accessTokenInfo) {
      if (isTxSource && !isTxLoginType) {
        return {
          code: 501,
          msg: '购买腾讯产品包必须使用QQ或微信登陆'
        }
      } else {
        const externalInfo = userinfo.external_info.filter(item => {
          return item.external_flag === loginType
        })
        let paramsData = {
          user_id: accessTokenInfo.access_token,
          user_flag: '1',
          third_user_id: externalInfo.length ? externalInfo[0].external_id : '',
          shop_cart_products: [{
            product_id: pid,
            price: pres.discountFee,
            count: 1
          }],
          client_type: '3'
        }
        if (loginType === 'weixin') {
          paramsData.extend_info = JSON.stringify({
            login_type: 2,
            wx_vu_id: externalInfo[0].vuserid
          })
        }
        const params = {
          data: JSON.stringify(paramsData),
          product_id: pid,
          is_support_wx: true
        }

        return this.fetch({
          method: 'GET',
          url: `${hostBusiness}/v1/qrcode/getFullQrcode.html`,
          params
        }).then(res => {
          if (type) {
            window.location.href = res.url
          }
          return {
            code: 0,
            url: res.url
          }
        })
      }
    } else {
      return {
        code: 500,
        msg: '请登陆'
      }
    }
  })
}

/**
 * 获取产品包详情
 * @param pid
 * @returns {Promise<Response> | * | Promise<AxiosResponse<any> | never>}
 */
export function getProductDetail (pid) {
  return this.fetch({
    method: 'GET',
    url: `${hostBusiness}/v3/extend/1/product/getProductDetail.html`,
    params: {
      data: {
        pid
      }
    }
  })
}
